import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";

export default function HorizontalBarCharts() {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    // Glassmorphism colors suited for a doctor or healthcare context
    const data = {
      labels: ["In-Patients", "Out-Patients", "Discharged"],
      datasets: [
        {
          label: "Patient Statuses",
          backgroundColor: [
            "rgba(37, 222, 43, 0.4)", // Light Green for In-Patients
            "rgba(33, 150, 243, 0.4)", // Light Blue for Out-Patients
            "rgba(255, 152, 0, 0.4)", // Light Orange for Discharged
          ],
          borderColor: [
            "rgb(76, 175, 80)", // Dark Green
            "rgb(33, 150, 243)", // Dark Blue
            "rgb(255, 152, 0)", // Dark Orange
          ],
          borderWidth: 1,
          data: [120, 80, 60], // Example counts for each category
        },
      ],
    };

    const options = {
      indexAxis: "y",
      maintainAspectRatio: false,
      aspectRatio: 0.9,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
            font: {
              size: 10, // Smaller text size for better clarity
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  return (
    <div className="card div-JXqxMvIsNq rounded-2" style={{ padding: "1rem", border: "none", height: "26.3rem" }}>
      <div
        style={{
          fontSize: "18px",
          fontWeight: "500",
          marginBottom: "0.5rem",
          color: "#575757",
        }}
      >
        Patient Overview
      </div>
      <Chart type="bar" data={chartData} options={chartOptions} />
    </div>
  );
}
